const PlanService = {
  // eslint-disable-next-line
  getPlans: async () => {
    const { data: en } = await ovpFetch('https://cdn.streamify.io/plans/plan_en.json', {
      noAuth: true,
      noExtraHeaders: true,
    });

    return en;
  },
  getManagePlanLink: async (returnPath) => {
    const { data } = await ovpFetch(`/stripe/plan/manage?return_path=${returnPath}`, {
      method: 'GET',
      defaultContentType: true,
    });
    return data;
  },
  getCheckoutLink: async (
    plan,
    billingInterval,
    currency = 'sek',
    trial = true,
    success_path,
    cancel_path,
  ) => {
    const { data } = await ovpFetch('/stripe/plan/checkout', {
      method: 'POST',
      body: JSON.stringify({
        plan,
        billing_interval: billingInterval,
        currency,
        trial,
        success_path,
        cancel_path,
      }),
      defaultContentType: true,
    });
    return data;
  },
};

// eslint-disable-next-line
export { PlanService };
